import { Body } from '@routific/hive';
import { useTranslation } from 'react-i18next';

const LoadingText: React.FC = () => {
  const { t } = useTranslation('components');
  return (
    <div data-testid="loading-text">
      <Body type='secondary'>
        {t('downloadCSVModal.loading.message')}
      </Body>
    </div >
  );
};

export default LoadingText;
